import App from '@/models/App'
import ShipUser from './ShipUser'

export default class ShipLaborInternationalDateLineRepeat extends App {
    static get entity() {
        return 'ShipLaborInternationalDateLineRepeats'
    }
    static all() {
        return this.query().withAllRecursive().get()
    }

    static fields() {
        return {
            id: this.attr(''),
            shipId: this.attr(''),
            repeatDate: this.attr(''),
            createdAt: this.attr(''),
        }
    }
    static apiConfig = {
        actions: {
            fetch(shipId) {
                return this.get(`${shipId}/labor/international/date/repeat`, {
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            save(shipId, params) {
                return this.post(
                    `${shipId}/labor/international/date/repeat`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(shipId, internationalDateId) {
                return this.delete(
                    `${shipId}/labor/international/date/${internationalDateId}`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: internationalDateId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
